export default "/_next/static/sounds/CONGRATS_PAGE_APPEARING_TONAL_2-3b59709ad0bb64f722c3c6cd8e97bba3.mp3";